import type { InvoiceLineFormItem } from '../InvoiceLinesForm';
import { createId } from '../../../../utils/create-id';

/** Factory for a locally-added invoice line. It has no server `id`; the local `key`
 * identifies the row in the UI until it is saved. */
export function createBlankLine(): InvoiceLineFormItem {
  return {
    key: createId(),
    description: null,
    quantity: null,
    unitPrice: null,
    unit: null,
    vatRate: null,
    vatAmount: null,
    totalAmountNoVat: null,
    totalAmountInclVat: null,
    discountPercent: null,
    recyclingFee: null,
    costCenterId: null,
    jobId: null
  };
}
